<!-- 
  搜索组件
  @param defaultValue [String] 默认值
  @emit change(item) item = 变更的数据对象
 -->
<template>
  <div class="search">
    <label for="search">
      <input 
        :class="{ max: info.inInput, w100: noAnimation }" 
        type="text" id="search" 
        v-model="info.value"
        @focus="focused"
        @input="searchItem"
        @blur="inputBlur"
        AUTOCOMPLETE="off"
        placeholder="请输入国家/地区"/>
      <i class="icon-sousuo"></i>
    </label>
    <dl 
      @mouseover="changeInfo('inSelect', true)"
      @mouseout="changeInfo('inSelect', false)"
      :class="{ show: info.inInput && info.value.length === 0 }">
      <dt>
        <span 
          :class="{ on: index === null }" 
          @mouseover="changeIndex(null)">热门</span>
        <span 
          v-for="(v, i) in list" 
          :key="v.title" 
          :class="{ on: index === i }"
          @mouseover="changeIndex(i)">
          {{ v.title }}
        </span>
      </dt>
      <dd v-show="index === null">
        <b>热门</b>
        <span 
          v-for="(v, i) in hot" :key="i"
          @click="selectedItem(v)">{{ v.name }}</span>
      </dd>
      <dd v-if="index !== null">
        <p v-for="(v, i) in list[index].options" :key="i">
          <b>{{ v.desc }}</b>
          <span 
            :class="sub | inHot(hot)" 
            v-for="(sub, idx) in v.subOptions" :key="idx"
            @click="selectedItem(sub)">{{ sub.name }}</span>
        </p>
      </dd>
    </dl>
    <ul class="list" :class="{ show: info.inInput && info.value.length !== 0 }">
      <li 
        v-for="(v, i) in matchList" :key="i"
        @click="selectedItem(v)">
        <b>{{ v.name }}</b>
        <span>{{ v.PinYin }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    defaultValue: {
      type: String,
      value: ''
    },
    noAnimation: {
      type: Boolean,
      value: false
    }
  },
  data () {
    return {
      info: {
        inInput: false, // 输入状态
        inSelect: false, // 选择中
        value: '', // 输入内容
      },
      hot: [],
      index: null,
      list: [
        {
          title: 'AB',
          options: []
        }, {
          title: 'CD',
          options: []
        }, {
          title: 'EFG',
          options: []
        }, {
          title: 'HIJ',
          options: []
        }, {
          title: 'KL',
          options: []
        }, {
          title: 'MN',
          options: []
        }, {
          title: 'OPQR',
          options: []
        }, {
          title: 'ST',
          options: []
        }, {
          title: 'UVWX',
          options: []
        }, {
          title: 'YZ',
          options: []
        }
      ],
      allData: [],
      matchList: []
    }
  },
  created () {
    // 设置默认值
    const defaultVal = this.defaultValue;
    defaultVal && (this.info = { ...this.info, value: defaultVal });
    // 获取国家信息
    this.getCountry().then(res => {
      const { list, hot, allData } = res;
      this.list = list;
      this.hot = hot;
      this.allData = allData;
    });
  },
  filters: {
    inHot (item, hot) {
      const inHot = hot.find(v => v.id === item.id);
      return inHot ? 'hot' : '';
    }
  },
  methods: {
    selectedItem (item) {
      this.$emit('change', item);
      this.changeInfo('value', item.name);
    },
    getCountry () {
      return new Promise(resolve => {
        const { getCountry: country } = this.$store.getters;
        const { list, hot, allData } = country;
        if ( !!list && !!hot && !!allData ) {
          resolve({ list, hot, allData });
          return;
        }
        this.requestCountry().then(res => {
          this.$store.commit('setCountry', res);
          resolve(res);
        })
      })
    },
    // 请求国家数据
    requestCountry () {
      return new Promise(resolve => {
        this.$axios.get('/country/all').then(res => {
          const { hotCountry, all } = res;
          // 重组数据
          const pyIndex = { 
            A: 0, B: 0, 
            C: 1, D: 1, 
            E: 2, F: 2, G:2, 
            H: 3, I: 3, J: 3, 
            K: 4, L: 4,
            M: 5, N: 5,
            O: 6, P: 6, Q: 6, R: 6,
            S: 7, T: 7,
            U: 8, V: 8, W: 8, X: 8,
            Y: 9, Z: 9
          };
          let list = [...this.list]; // 按拼音重组
          let allData = []; // 所有数据，用于搜索
          Object.keys(all).forEach(v => {
            const index = pyIndex[v];
            list[index].options.push({ desc: v, subOptions: all[v] });
            allData = [...allData, ...all[v]];
          });
          resolve({ list, hot: hotCountry, allData });
        })
      })
    },
    focused () {
      this.changeInfo('inInput', true);
      !!this.info.value && this.searchItem();
    },
    // 搜索匹配项
    searchItem () {
      const { info, allData } = this;
      const val = info.value.toUpperCase();
      const res = allData.filter(v => {
        return v.PinYin.includes(val) || 
                v.PinYinCode.includes(val) || 
                v.name.includes(val) || 
                Number(val) === v.id;
      });
      this.matchList = res;
    },
    // 输入框失去焦点
    inputBlur () {
      setTimeout(() => {
        this.changeInfo('inInput', false);
      }, 100);
    },
    // 修改info
    changeInfo (attr, val) {
      let info = { ...this.info };
      info[attr] = val;
      this.info = info;
    },
    // 修改索引
    changeIndex (index) {
      this.index = index;
    }
  }
}
</script>

<style scoped src="./index.css"></style>